import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    accountDetails: {},
    allWorkflowTemplates: {},
};

export const accountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {
        setAccountDetails: (state, action) => {
            state.accountDetails = action.payload;
        },
        setAllWorkflowTemplates: (state, action) => {
            state.allWorkflowTemplates = action.payload;
        },
    },
});

export const { setAccountDetails, setAllWorkflowTemplates } = accountSlice.actions;

export default accountSlice.reducer;
